// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"image-module--image-wrapper--vXbch"};